import { gql } from 'apollo-angular';

const HPF = gql`
  fragment HPF on HorizontalProgramFinder {
    headerText
    headerTag
    horizontalProgramFinderCollection {
      items {
        ... on BackgroundColor {
          color
        }
      }
    }
  }
`;

export { HPF };
